import { AlertCircle } from "lucide-react";
import { OuterContentContainer } from "@shared/ui/OuterContentContainer";
import { Type } from "@shared/ui/Type";

export type Props = {
  message?: string | undefined;
};

export function DashboardAlertBanner({ message }: Props) {
  if (!message) return null;

  return (
    <OuterContentContainer
      className="w-full bg-error-800 py-3 md:py-3"
      innerClassName="flex flex-row gap-2"
    >
      <AlertCircle className="h-4 w-4 text-brand-50 mt-[2px] shrink-0" />
      <Type variant="h6" className="text-brand-50">
        {message}
      </Type>
    </OuterContentContainer>
  );
}

export default DashboardAlertBanner;
